import { UserRole } from "tm-shared/types";

export interface ContractCapabilities {
    canManageContract: boolean;
}

export const getContractCapabilities = (
    role: UserRole | null,
): ContractCapabilities => ({
    canManageContract: role === UserRole.Sv,
});
